import { render, staticRenderFns } from "./area-progress.vue?vue&type=template&id=31f13fe7&scoped=true&"
import script from "./area-progress.vue?vue&type=script&lang=js&"
export * from "./area-progress.vue?vue&type=script&lang=js&"
import style0 from "./area-progress.vue?vue&type=style&index=0&id=31f13fe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f13fe7",
  null
  
)

export default component.exports